// eslint-disable-next-line no-restricted-imports
import { Checkbox as ArcCheckbox, CheckboxProps } from 'arc';
import { forwardRef, Ref, useMemo } from 'react';
import { useApplicationType } from '../common/hooks/use-application-type';

export const Checkbox = forwardRef(function (props: CheckboxProps, ref?: Ref<HTMLInputElement>) {
    const { isFirstResponder } = useApplicationType();

    const size = useMemo(() => {
        if (props.size) {
            return props.size;
        }

        if (isFirstResponder) {
            return 'lg';
        }

        return;
    }, [isFirstResponder, props.size]);

    return <ArcCheckbox ref={ref} {...props} size={size} />;
});
